import GetAppIcon from '@mui/icons-material/GetApp';
import UploadIcon from '@mui/icons-material/Upload';
import { Box, Button } from '@mui/material';

interface FooterActionsProps {
  isUploadingStructure: boolean;
  onStructureFileUpload: (file: File) => Promise<void>;
  onDownloadStructureTemplate: () => void;
  onSaveStructureAsDefault?: (() => Promise<void>) | undefined;
}

const FooterActions: React.FC<FooterActionsProps> = ({
  isUploadingStructure,
  onStructureFileUpload,
  onDownloadStructureTemplate,
  onSaveStructureAsDefault,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, gap: 1, flexWrap: 'wrap' }}>
      <input
        type="file"
        accept=".csv"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            onStructureFileUpload(file);
          }
        }}
        style={{ display: 'none' }}
        id="structure-upload-details"
      />
      <label htmlFor="structure-upload-details">
        <Button
          component="span"
          variant="outlined"
          startIcon={<UploadIcon />}
          disabled={isUploadingStructure}
          sx={(theme) => ({
            mr: 1,
            backgroundColor: theme.palette.greyLight,
            color: theme.palette.text.primary,
            borderColor: theme.palette.bidlogiq.brick,
            '&:hover': {
              backgroundColor:
                theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[400],
              borderColor: theme.palette.bidlogiq.brick,
            },
          })}
        >
          {isUploadingStructure ? 'Uploading...' : 'Upload Structure'}
        </Button>
      </label>
      <Button
        onClick={onDownloadStructureTemplate}
        variant="outlined"
        startIcon={<GetAppIcon />}
        size="small"
        sx={(theme) => ({
          backgroundColor: theme.palette.greyLight,
          color: theme.palette.text.primary,
          borderColor: theme.palette.bidlogiq.brick,
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[400],
            borderColor: theme.palette.bidlogiq.brick,
          },
        })}
      >
        Download Current Structure
      </Button>
      {onSaveStructureAsDefault && (
        <Button
          onClick={onSaveStructureAsDefault}
          variant="contained"
          size="small"
          aria-label="Save outline as default template"
          title="Save outline as default template"
          sx={(theme) => ({
            ml: 'auto',
            backgroundColor: theme.palette.bidlogiq.brick,
            color: theme.palette.common.white,
            '&:hover': {
              backgroundColor: theme.palette.bidlogiq.rust,
            },
            '&:focus-visible': {
              outline: `2px solid ${theme.palette.bidlogiq.brick}`,
              outlineOffset: '2px',
            },
          })}
        >
          Save as default
        </Button>
      )}
    </Box>
  );
};

export default FooterActions;
